import script from "./DashboardOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardOverview.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardOverview.vue?vue&type=style&index=0&id=212bfac6&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212bfac6"]])

export default __exports__